module.exports = __webpack_public_path__ + "img/eye-open.22870c3b.svg";